import React from 'react';
import Hero from '../components/Hero';
import Studio from '../components/Studio';
import InstrumentShowcase from '../components/InstrumentShowcase';
import OfflineClasses from '../components/OfflineClasses';
import AIFeatures from '../components/AIFeatures';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <>
      <Hero />
      <Studio />
      <InstrumentShowcase />
      <OfflineClasses />
      <AIFeatures />
      <Contact />
      <Footer />
    </>
  );
}
